import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=2b9e4b5c&scoped=true"
import script from "./StudentForm.vue?vue&type=script&lang=js"
export * from "./StudentForm.vue?vue&type=script&lang=js"
import style0 from "./StudentForm.vue?vue&type=style&index=0&id=2b9e4b5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e4b5c",
  null
  
)

export default component.exports